import validate from "F:/web/node_modules/nuxt/dist/pages/runtime/validate.js";
import router_45global from "F:/web/middleware/router.global.js";
export const globalMiddleware = [
  validate,
  router_45global
]
export const namedMiddleware = {}